import { useScroll, motion } from 'framer-motion';

function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  return (
    <motion.div
      style={{
        scaleX: scrollYProgress,
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        height: '2px',
        background: '#EFEAE1',
        transformOrigin: '0%',
        zIndex: 999,
        pointerEvents: 'none',
      }}
    />
  );
}

export default ScrollProgress;
